// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"1768578f","158":"b684fa42","451":"cff8dfbc","893":"ef1758df"}[chunkId] + ".chunk.js";
};